import { AuxAssign } from '@/types/dashboard';

// Determine if a given aux type exists in AuxAssign
export const hasAuxType = (auxAssign: AuxAssign | undefined, typeCode: number): boolean => {
  if (!auxAssign) return false;
  const inAssign = Array.isArray(auxAssign.aux_assign) && auxAssign.aux_assign.includes(typeCode);
  const inEquipment = Array.isArray(auxAssign.equipment) && auxAssign.equipment.some(e => e.type_code === typeCode);
  return inAssign || inEquipment;
};

// Compute pH color based on value (0-14 scale)
export const getPhColor = (value: number): string => {
  const segment = 14 / 5;
  if (value >= 0 && value <= segment) return '#DC2626'; // Red
  if (value > segment && value <= 2 * segment) return '#F97316'; // Orange
  if (value > 2 * segment && value <= 3 * segment) return '#10B981'; // Green
  if (value > 3 * segment && value <= 4 * segment) return '#F97316'; // Orange
  return '#DC2626'; // Red
};

// Compute ORP color based on difference to desired value
export const getOrpColorByDesired = (actual: number, desired: number, isNaked?: boolean): string => {
  if (isNaked) {
    return '#10B981'; // Green when naked system
  }
  const diff = Math.abs(actual - desired);
  if (diff <= 15) return '#10B981'; // Green
  if (diff > 15 && diff <= 30) return '#FBBF24'; // Yellow
  if (diff > 30 && diff <= 45) return '#F97316'; // Orange
  return '#DC2626'; // Red
};